import {memo} from "react";
import {
	Table, Tag
} from "antd";
import {
	numberFormat,
	renderDate
} from "~/utils";
import {
	slipTypeLabels,
	calcTypeLabels,
	calcTypeColors
} from "~/features/SalarySlip/constants";

function PayDetailExpense({items = []}) {

	const columns = [
		{ title: 'Mã đơn', dataIndex: 'code', key: "code", width: '90px', render: (_, item) => (<div>PL{item?.id}</div>)},
		{ title: 'Kỳ lương', dataIndex: 'salaryMonth', key: "salaryMonth", width: '120px', render: (_, item) => (<div><p>Tháng {renderDate(item?.salaryMonth, 'month')}</p></div>)},
		{ title: 'Ngày chi thực tế', dataIndex: 'paidDate', key: "paidDate", width: '130px', render: (_, item) => (<div><p>{renderDate(item?.paidDate)}</p></div>)},
		{ title: 'Loại phiếu', dataIndex: 'slipType', key: 'slipType', width: '160px', render:(_, item) => (<b>{slipTypeLabels[item?.slipType] || item?.slipType}</b>)},
		{ title: 'Loại tính', dataIndex: 'calcType', key: "calcType", width: '120px', render: (_, item) => (<Tag color={calcTypeColors[item?.calcType]}>{calcTypeLabels[item?.calcType] || item?.calcType}</Tag>)},
		{ title: 'Số tiền', dataIndex: 'price', key: "price", width: '160px', render: (_, item) => (<p><b>{numberFormat(item?.price)}đ</b></p>)},
		{ title: 'Ghi chú', dataIndex: 'note', key: "note", render: (_, item) => (item?.note)},
	];


	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} rowKey="id" dataSource={items} scroll={{ y:550 }} pagination={false} />
			</div>
		</div>
	)
}

export default memo(PayDetailExpense);
